<template>
  <div class="to-paid" v-if="arrears && arrears.length">
    <div v-for="arrear in arrears" :key="arrear.uuid" class="arrear">
      <span>{{ arrear.name }} {{ arrear.date | date('yyyy-MM-DD') }}</span><span>{{ arrear.value | currency }}</span>
    </div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

export default {
  mounted() {
    this.getArrears();

    this.$root.$on("logged", () => {
      // this.getArrears();
      // this.$forceUpdate();
      this.getArrears().then(() => {
        this.$forceUpdate();
      });
    });

    this.$root.$on("logged-out", () => {
      // this.getArrears();
      // this.$forceUpdate();
      this.getArrears().then(() => {
        this.$forceUpdate();
      });
    });
  },
  data() {
    return {
      arrears: [],
    };
  },
  methods: {
    async getArrears() {
      let today = new Date();
      let year = today.getFullYear();
      let month = today.getMonth() + 1;

      this.date = year + "-" + month;

      let lastMonths = this.$piggyBank.data.wallets
        .filter(
          (wallet) =>
            new Date(wallet.year, wallet.month - 1, 1).getTime() <=
            new Date(year, month - 1, 1).getTime()
        )
        .sort((a, b) => {
          return new Date(a.year, a.month - 1, 1).getTime() <=
            new Date(b.year, b.month - 1, 1).getTime()
            ? 1
            : -1;
        })
        .splice(0, 2);

      let toArrears = [];

      for await (let item of lastMonths) {
        let expenses = await this.$piggyBank.data
          .getWallet(item.year, item.month)
          .then((wallet) => {
            let expenseDate = new Date(wallet.year, wallet.month, 1);
            expenseDate.setDate(expenseDate.getDate() - 1);

            return wallet.data.expenses
              .map(({ id, name, value, date, done }) => {
                return { 
                  id, 
                  name, 
                  value, 
                  date: new Date(date || expenseDate), 
                  done, 
                  uuid: uuid() 
                };
              });
          })
          .catch((error) => {
            console.log('error', error);
          });

        if (expenses) {
          toArrears.push(...expenses);
        }
      }

      // today.setDate(today.getDate() + 7); dodanie tygodnia
      this.arrears = toArrears.filter((arrear) => {
        return arrear.value && !arrear.done && arrear.date.getTime() <= today.getTime();
      });

      // if (this.last) {
      //   this.$piggyBank.data
      //     .getWallet(this.last.year, this.last.month)
      //     .then((wallet) => {
      //       this.arrears = wallet.data.expenses.filter(
      //         (expense) => expense.value && !expense.done
      //       );
      //     });
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.to-paid {
  background: #0005;
  color: white;
  font-weight: 100;
  margin: 10px;
  padding: 10px;
  border-radius: 10px;

  .arrear {
    display: flex;
    justify-content: space-between;
  }
}
</style>